import { render, staticRenderFns } from "./choose-multiple-generic.vue?vue&type=template&id=b88a3ef0"
import script from "./choose-multiple-generic.vue?vue&type=script&lang=js"
export * from "./choose-multiple-generic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports